
export const FETCH_SET_SELECTED_ORGANISATION_SUCCESS = 'FETCH_SET_SELECTED_ORGANISATION_SUCCESS'

